import api from "./Api";

class ReleaseService {
  getAll() {
    return api.get("/v1/releases").then((r) => r.data);
  }
  get(id) {
    return api.get(`/v1/releases/${id}`).then((r) => r.data);
  }
  save(data, update = false) {
    return api[update ? "put" : "post"]("/v1/releases", data).then(
      (r) => r.data
    );
  }
  remove(id) {
    return api.delete(`/v1/releases/${id}`).then((r) => r.data);
  }
  getPublic(slug = "") {
    return api
      .get(slug ? `/v1/releases/public/${slug}` : "/v1/releases/public")
      .then((r) => r.data);
  }
  getUnread() {
    return api.get("/v1/releases/unread").then((r) => r.data);
  }
  markRead() {
    return api.post("/v1/releases/mark-read").then((r) => r.data);
  }
  getOData(payload) {
    return api.get("/OData/Release" + payload).then((response) => {
      const data = response.data;
      if (Array.isArray(data?.value)) return data;

      return {
        value: Array.isArray(data?.Data) ? data.Data : [],
        "@odata.count": data?.["@odata.count"] || data?.Data?.length || 0,
      };
    });
  }
  upload(files) {
    const data = new FormData();
    files.forEach((file) => data.append("files", file));
    return api
      .post("/v1/releases/upload", data)
      .then((response) => response.data);
  }
}
export default new ReleaseService();
